<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left-title" class="">
        <h1 class="title is-3">
            <span class="">Statistiques de ventes</span>
            <!-- <span v-if="orderedSales && !isLoading" class="has-text-weight-light has-text-grey">
              ({{sales.length}} Total)
            </span>
            <span v-else-if="isLoading" class="is-size-6">Chargement ...</span> -->
        </h1>
      </div>
      <div class="column is-narrow is-paddingless is-border-left" slot="right-content">
        <a class="page-header-btn tooltip is-square is-tooltip-left is-tooltip-primary" :data-tooltip="fullscreen ? 'Réduire' : 'Agrandir'" @click="toggleFullscreen">
          <span class="icon">
            <i class="far" :class="fullscreen ? 'fa-compress-wide' : 'fa-expand-wide'"></i>
          </span>
        </a>
      </div>
    </sticky>

    <div class="page-content is-padding-top">
      <div
        class="columns is-sticky-in-mainColumn is-zindex-8 is-gapless has-bg-white is-margin-left is-margin-right is-border">
        <div class="column is-10 is-8-widescreen">
          <stats-menu></stats-menu>
        </div>
        <div class="column"></div>
      </div>

      <div class="is-padding-left is-padding-right is-padding-top" data-sticky-pos-top="headerStats">

        <div class="columns is-gapless is-margin-bottom is-border" v-if="showfakeStats">
          <div class="column is-narrow" style="width: 61.4%">
            <img class="is-block" src="static/StatsTemp/statistique-PeintureTemp-img_1.jpg" alt="">
          </div>
          <div class="column">
            <img class="is-block" src="static/StatsTemp/statistique-PeintureTemp-img_2.jpg" alt="">
          </div>
        </div>

        <div class="has-bg-white is-border ">
          <div class="columns is-gapless">
            <div class="column is-3 is-border-right">
              <div class="field is-padding-left is-padding-right has-bg-lighter">
                <p class="control has-icons-left has-icons-right">
                  <flat-pickr id="startDatePicker" :config="periodConfigDate"
                              v-model="rawStartDate"
                              @on-change="updateStartDate"
                              @on-close="resetPeriod"
                              class="input is-fullwidth is-borderless has-bg-lighter"
                              name="date">
                  </flat-pickr>
                  <span class="icon is-small is-left has-text-black">
                    <i class="fal fa-calendar-alt is-size-4"></i>
                  </span>
                  <span class="icon is-large is-right has-text-dark">
                    <i class="far fa-chevron-down is-size-7"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-3 is-border-right">
              <div class="field is-padding-left is-padding-right has-bg-lighter">
                <p class="control has-icons-left has-icons-right">
                  <flat-pickr id="endDatePicker" :config="periodConfigDate"
                              v-model="rawEndDate"
                              @on-close="resetPeriod"
                              @on-change="updateEndDate"
                              class="input is-fullwidth is-borderless has-bg-lighter"
                              name="date">
                  </flat-pickr>
                  <span class="icon is-small is-left has-text-black">
                    <i class="fal fa-calendar-alt is-size-4"></i>
                  </span>
                  <span class="icon is-large is-right has-text-dark">
                    <i class="far fa-chevron-down is-size-7"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right">
              <div class="select is-fullwidth">
                <select id="period" @change="setCustomPeriod" v-model="period" class="is-borderless">
                  <option :value="null">Périodes</option>
                  <option v-for="period in periods" :value="period">{{period.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-paddingless is-border-left is-border-right">
          <div class="columns is-multiline is-padding-top-small is-padding-bottom-small is-padding-left-small">
            <div class="control column is-narrow is-paddingless" v-for="s in availableAdvStatusList">
              <label class="checkbox" :for="s.value">
                <input type="checkbox" class="" :value="s.value"
                       :name="s.value" :id="s.value" v-model="filters.status">
                <span class="tag" :class="s.color">
                  <span>{{s.label}}</span>
                  <span class="icon">
                    <i class="far"
                       :class="!filters.status || !filters.status.length || filters.status.includes(s.value) ? 'fa-check-square' : 'fa-square'"></i>
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="currentTab === TAB_MODES.TABLE"
             class="is-border-top is-radius-top-left-large is-radius-top-right-large"
             id="tableaux">
          <!-- <div class="columns is-vcentered is-gapless is-border-right is-border-left is-border-bottom is-radius-top-left-large is-radius-top-right-large has-bg-light">
            <div class="column">
              <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns ">
                <a class="button is-small is-white is-transform-none is-padding-left-small is-padding-right-small is-min-width-0 is-active">Custom</a>
              </div>
            </div>
          </div> -->
          <div
            class="stat-header stat-header--sticky is-border-right is-border-left has-bg-white"
            :style="stickyStyles"
          >
            <div class="columns is-gapless is-size-6-touch is-size-6-desktop is-size-5-widescreen">
              <div class="columns column is-2">
                <div class="column is-th is-7 is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('seller_name')">
                    <span>Commercial</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'seller_name'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'seller_name' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-th is-5 is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('company_name')">
                    <span>Société</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'company_name'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'company_name' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
              </div>
              <div class="columns column is-6">
                <div v-if="isDistributeurMode"
                     class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('promoteur_name')">
                    <span>Promoteur</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'promoteur_name'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'promoteur_name' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('program_name')">
                    <span>Programmes</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'program_name'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'program_name' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-1 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('lot_ref')">
                    <span>Lot</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'lot_ref'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'lot_ref' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('buyer_name')">
                    <span>Contact</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'buyer_name'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'buyer_name' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('origin_name')">
                    <span>Origine</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'origin_name'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'origin_name' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-left-small"
                     :class="{'is-2': isDistributeurMode, 'is-5': isPromoteurMode}">
                  <a @click="sort('sale_price_with_discount')">
                    <span>Prix de Vente</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'sale_price_with_discount'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'sale_price_with_discount' && sortOrder === 'asc'"
                       class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
              </div>
              <div class="columns column is-4">
                <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('seller_com')">
                    <span>Com Vendeur</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'seller_com'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'seller_com' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('company_com')">
                    <span>Com Société</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'company_com'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'company_com' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
                <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('CA')">
                    <span>CA Société</span>
                    <span class="icon is-pulled-right">
                    <i v-if="sortBy !== 'CA'" class="fas fa-sort"></i>
                    <i v-else-if="sortBy === 'CA' && sortOrder === 'asc'" class="fas fa-sort-up"></i>
                    <i v-else class="fas fa-sort-down"></i>
                  </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="stat-lignes is-size-6-touch is-size-6-desktop is-size-5-widescreen">
            <sale-row v-for="s in orderedSales" :key="s.key" :sale="s"
                      class="has-bg-white is-border is-relative is-clipped is-margin-bottom-small"></sale-row>
            <sale-row :sale="totalSales" :is-total="true"
                      class="is-dark-blue stat-ligne--synthese stat-ligne--synthese--nowrap-xLargeScreen"></sale-row>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import SaleRow from './SaleRow'
  import StatsMenu from '../StatsMenu'
  import { DefaultValues, StatsPeriodMx, StatsStickyMx } from '@/mixins'
  import { sortBy, debounce } from 'lodash'

  const TAB_MODES = Object.freeze({
    TABLE: 'TABLE',
    CHART: 'CHART'
  })

  export default {
    name: 'SalesStats',
    mixins: [DefaultValues, StatsPeriodMx, StatsStickyMx],
    components: {
      Datepicker,
      SaleRow,
      StatsMenu
    },
    data () {
      return {
        filters: {
          status: []
        },
        initFilters: {
          status: []
        },
        sortBy: null,
        sortOrder: 'desc',
        TAB_MODES: TAB_MODES,
        currentTab: TAB_MODES.TABLE,
        sales: [],
        currentEntity: null,
        isLoading: false,
        startDatePicker: null,
        endDatePicker: null,
        fullscreen: false
      }
    },
    computed: {
      ...mapGetters(['isDistributeurMode', 'isPromoteurMode']),
      showfakeStats () {
        return JSON.parse(this.$configs.FAKE_STATS) === 1
      },
      availableAdvStatusList () {
        return [
          { value: 'reserved', label: 'Réservation', color: 'is-reserve' },
          { value: 'sold', label: 'Acte', color: 'is-acte' },
          { value: 'canceled_by_admin', label: 'Annulation', color: 'is-draft' }
        ]
      },
      orderedSales () {
        if (this.sortBy) {
          let sales = sortBy(this.sales, (x) => {
            return x[this.sortBy]
          })
          if (this.sortOrder === 'asc') {
            return sales
          } else {
            return sales.reverse()
          }
        } else {
          return this.sales
        }
      },
      entitiesPk () {
        return this.entities.map(x => {
          return x.pk
        })
      },
      totalSales () {
        let total = this.sales.reduce((a, b) => {
          return {
            sale_price_with_discount: b.sale_price_with_discount ? a.sale_price_with_discount + b.sale_price_with_discount : a.sale_price_with_discount + 0,
            CA: b.CA ? a.CA + Math.floor(b.CA) : a.CA + 0,
            seller_com: b.seller_com ? a.seller_com + Math.floor(b.seller_com) : a.seller_com + 0,
            company_com: b.company_com ? a.company_com + Math.floor(b.company_com) : a.company_com + 0
          }
        }, { sale_price_with_discount: 0, CA: 0, seller_com: 0, company_com: 0 })
        return {
          seller_name: 'Synthèse',
          program_name: null,
          lot_ref: null,
          buyer_name: null,
          origin_name: null,
          sale_count: this.sales.length,
          sale_price_with_discount: total.sale_price_with_discount,
          CA: total.CA,
          seller_share: total.CA * 100 / total.sale_price_with_discount,
          seller_com: total.seller_com,
          company_com: total.company_com
        }
      }
    },
    watch: {
      'filters.status' (val, oldVal) {
        this.loadSalesData()
      }
    },
    methods: {
      changeTab (tab) {
        this.currentTab = tab
      },
      loadSalesData: debounce(function () {
        this.isLoading = true
        let startDate = moment(this.rawStartDate, 'YYYY-MM-DD')
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        let delta = endDate.diff(startDate, 'days')
        let previousStartDate = startDate.clone().subtract(delta, 'days')
        let previousEndDate = endDate.clone().subtract(delta, 'days')

        let params = {
          entities: this.entities,
          start_date: startDate.format('DD/MM/YYYY'),
          end_date: endDate.format('DD/MM/YYYY'),
          previous_start_date: previousStartDate.format('DD/MM/YYYY'),
          previous_end_date: previousEndDate.format('DD/MM/YYYY'),
          status: this.filters.status
        }
        this.$api.statisticService.getSaleData(params).then(r => {
          this.sales = r.data.sales.map(sale => {
            if (sale.seller_share === 0) {
              sale.seller_share = null
            }
            if (sale.sale_price_with_discount === 0) {
              sale.sale_price_with_discount = null
            }
            if (sale.sale_price_with_discount && (sale.seller_share || sale.company_share)) {
              sale.CA = (sale.sale_price_with_discount * (sale.seller_share / 100)) + (sale.sale_price_with_discount * (sale.company_share / 100))
              sale['seller_com'] = sale.sale_price_with_discount * sale.seller_share / 100
              sale['company_com'] = sale.sale_price_with_discount * sale.company_share / 100
            } else {
              sale.CA = null
            }
            return sale
          })
          this.isLoading = false
        })
      }, 300),
      sort (sortBy) {
        if (this.sortBy !== sortBy) {
          this.sortOrder = 'asc'
        } else {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        }
        this.sortBy = sortBy
      },
      updateStartDate (dates) {
        let startDate = moment(dates[0])
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        if (startDate.isAfter(endDate)) {
          this.rawEndDate = startDate.endOf('month').toDate()
        }
        this.loadSalesData()
      },
      updateEndDate (d) {
        this.loadSalesData()
      },
      toggleFullscreen () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('body').classList.add('has-contentmain-fullscreen')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen-leave')
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('body').classList.add('has-contentmain-fullscreen-leave')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen')
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      }
    },
    created () {
      this.filters.status = [this.advStatusData.sold.value, this.advStatusData.reserved.value]
      this.rawStartDate = moment().startOf('year').toDate()
      this.rawEndDate = moment().endOf('month').toDate()
      this.loadSalesData()
      this.initPeriods()
    },
    mounted () {
      // this.startDatePicker = document.getElementById('startDatePicker')
      // this.endDatePicker = document.getElementById('endDatePicker')
    }
  }
</script>

<style>
  #xstartDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }

  #xendDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }

  .hiddenDatePicker input {
    visibility: hidden;
    width: 0px;
    height: 0px;
    overflow: hidden;
  }

  div.inline {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/sale/SaleStats.vue